import {UI, type UIChild} from "../../../stem-core/ui/UIBase";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {styleRule, StyleSheet} from "../../../stem-core/ui/Style";

export class InputLabelStyle extends StyleSheet {
    @styleRule
    container = {
        display: "inline-block",
        marginBottom: 8,
        fontSize: this.themeProps.FONT_SIZE_SMALL,
        fontWeight: this.themeProps.FONT_WEIGHT_BOLD,
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    }
}

interface InputLabelOptions {
    label?: UIChild;
}

@registerStyle(InputLabelStyle)
export class InputLabel extends UI.Element<InputLabelOptions> {
    render() {
        return this.options.label;
    }
}
